jQuery(document).ready(function ($) {
    "use strict";

	$('.full-width-accordion__heading').on('click', function(e) {
        $(this).next('.full-width-accordion__content').slideToggle('200');
        $(this).children('.full-width-accordion__plus-icon').toggleClass('full-width-accordion__plus-icon--active');
        $(this).toggleClass('active');
    });

    $('.full-width-accordion__content').first().css('display', 'block');
    $('.full-width-accordion__heading').first().children().addClass('full-width-accordion__plus-icon--active');
    $('.full-width-accordion__heading').first().addClass('active');

});
